import { useState } from 'react';

export const useStatusString = () => {
    return (status) => {
      const statusMap = {
        0: { statusString: 'Pending', className: 'yellow' },
        1: { statusString: 'Processing', className: 'green' },
        2: { statusString: 'Shipped', className: 'green' },
        3: { statusString: 'Delivered', className: 'green' },
        4: { statusString: 'Cancelled', className: 'red' }
      };
      const statusObj = statusMap[status] ?? { statusString: '', className: '' };
      return <p className={`txt ${statusObj.className}`}>{statusObj.statusString}</p>;
    };
};

export const useStock = () => {
  return (stock) => {
    const stockMap = {
      true: { statusString: 'In stock', className: 'green' },
      false: { statusString: 'Out of stock', className: 'red' },
    };
    const stockObj = stockMap[stock] ?? { statusString: '', className: '' };
    return <p className={`txt ${stockObj.className}`}>{stockObj.statusString}</p>;
  };
};

export default function useToggle(initialValue = false) {
  const [toggled, setToggled] = useState(initialValue);

  function toggle() {
    setToggled(!toggled);
  }

  function isToggled() {
    return toggled;
  }

  return { toggle, isToggled };
}

// export function formatPrice(price) {
//   return price.toLocaleString('da-DK', { style: 'currency', currency: 'DKK' });
// }
export function formatPrice(price) {
  if (!price || isNaN(price)) return '0'; 
  const userLocale = navigator.language || 'da-DK';
  return price.toLocaleString(userLocale, { style: 'currency', currency: userLocale === 'da-DK' ? 'DKK' : 'USD' });
}

export function formatDate(date) {
  if (!date || isNaN(new Date(date).getTime())) return ''; 
  if (typeof date === 'number' || /^\d{8}$/.test(date)) {
    const str = date.toString();
    const year = str.substring(0, 4);
    const month = str.substring(4, 6);
    const day = str.substring(6, 8);
    return new Date(`${year}-${month}-${day}`).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  }
  return new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}

export function formatDateTime(dateTime) {
  if (!dateTime || isNaN(new Date(dateTime).getTime())) return ''; 
  const date = new Date(dateTime);
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours() % 12 || 12;
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
  return `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
}

export function toTitleCase(str) {
  // if (!str || typeof str !== 'string') return ''; 
  // return str.replace(/\w\S*/g, (txt) =>
  //   txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  // );
  return str;
}